import React from 'react'
import Chats from './Chats'
import { chatSelector } from '../../../../../store/selector';
import { connect } from 'react-redux'

function MiddleContent() {
  return (
    <Chats />
  )
}

const stateToProps = state => ({
  conversationList: chatSelector.getChatDynamic(state, 'conversationList')
});
export default connect(stateToProps)(MiddleContent);


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/modules/middleContent/index.js